var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-table',{attrs:{"columns":_vm.columns,"rows":_vm.files},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.label ? row.label : row.filename))]}},{key:"date",fn:function(ref){
var row = ref.row;
return [_c('ui-relative-time',{attrs:{"date":row.creationDate,"min":"-PT30M","format":"L LT"}})]}},{key:"actions",fn:function(ref){
var row = ref.row;
return [_c('ui-link',{staticClass:"first-link",on:{"click":function($event){return _vm.$emit('download', row)}}},[_vm._v("Herunterladen")]),_c('ui-link',{on:{"click":function($event){return _vm.$emit('remove', row)}}},[_vm._v("Löschen")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }